import { Button } from 'react-bootstrap';
import { ExternalLink, RefreshCw } from 'lucide-react';
import type { GigOrderReference } from '@/models/GigWorker';

interface GigOrderDetailActionProps {
  reference: GigOrderReference | null | undefined;
  lookupFailed: boolean;
  onOpen: () => void;
  onRetry: () => void;
}

/** Shows the GIG detail action only when the OMS order resolves to a persisted Gigwork order. */
export function GigOrderDetailAction({ reference, lookupFailed, onOpen, onRetry }: GigOrderDetailActionProps) {
  if (lookupFailed) {
    return (
      <span className="me-4">
        <Button variant="outline-warning" onClick={onRetry}>
          <RefreshCw className="h-4 w-4 me-2" />
          Retry GIG Lookup
        </Button>
      </span>
    );
  }

  if (!reference) {
    return null;
  }

  return (
    <span className="me-4">
      <Button variant="outline-info" onClick={onOpen}>
        <ExternalLink className="h-4 w-4 me-2" />
        View GIG Order
      </Button>
    </span>
  );
}
